import React, { useEffect } from 'react';
import { Card } from './../Card/Card';

export const RouteLoading = ({ images }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/venobox/2.1.3/venobox.min.js';
    script.onload = () => {
      new window.VenoBox({
        selector: '.my-image-links',
        numeration: true,
        infinigall: true,
        share: true,
        spinner: 'rotating-plane',
      });
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Card title={__('routes.loading')}>
      {images?.length > 0 ? (
        <div className="row">
          {Object.keys(images).map((key) => (
            <div className="col-2 mt-1">
              <div className="border-1 border shadow-sm">
                <div className="card-body p-1">
                  <a className="my-image-links" data-gall="gallery01" href={images[key].url}>
                    <img src={images[key].thumbnailUrl} className="w-100" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>Trasa nie posiada przypisanych zdjęć z załadunku.</p>
      )}
    </Card>
  );
};
